import React, { Fragment } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./Pages/Home";

/**
 * @author
 * @function Routes
 **/

const Routes = props => {
  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
        </Switch>
        
      </BrowserRouter>
      
    </>
  );
};

export default Routes;
